import {BaseEvent} from "../BaseEvent";
import {GatewayAlarmStatus} from "../../models/notification/GatewayAlarmStatus";

export class GatewayStatusChangedNtf extends BaseEvent {
  public static NAME = 'gatewayStatusChanged';
  public value: GatewayAlarmStatus;

  constructor(status: GatewayAlarmStatus) {
    super(GatewayStatusChangedNtf.NAME);

    this.value = status;
  }
}
